import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);

import Stampa from './components/Stampa.vue'
import NcChip from './components/NcChip.vue'
import Paginator from './components/Paginator.vue'
import { userService } from "./services/userServices.js";
import PhotoCarusel from './components/PhotoCarusel.vue'
import vuetify from './plugins/vuetify';
import VueSuggestion from './components/Suggestion.vue'
import InsAna from './components/InsAna.vue'
import Nc from './components/Nc.vue'
import AnaDetail from './components/AnaDetail.vue'
import AutoCompleteAna from './components/AutoCompleteAna.vue'
import MapTemplate from './components/MapTemplate.vue'
import Mappa from './components/Mappa.vue'
import MapWithInfo from './components/MapWithInfo.vue'
import SelectAc from './components/SelectAc.vue'
import './components/vue-suggestion.css';
import '@mdi/font/css/materialdesignicons.css'
const Home = () => import('./views/Home.vue')
const ListaAc = () => import('./views/ListaAc.vue')
const DettaglioAc = () => import('./views/DettaglioAc.vue')
const DettaglioAna = () => import('./views/DettaglioAna.vue')
const DettaglioNc = () => import('./views/DettaglioNc.vue')
const Anagrafe = () => import('./views/Anagrafe.vue')
const Login = () => import('./views/Login.vue')
const Stampe = () => import('./views/Stampe.vue')

const SceltaComune = () => import('./views/SceltaComune.vue')
//parte office
const Rilievi = () => import('./views/office/Rilievi.vue')


Vue.component('stampa', Stampa)
Vue.component('vue-suggestion', VueSuggestion)
Vue.component('selectAc', SelectAc)
Vue.component('mapTemplate', MapTemplate)
Vue.component('mappa', Mappa)
Vue.component('paginator', Paginator)
Vue.component('mapWithInfo', MapWithInfo)
Vue.component('ncChip', NcChip)
Vue.component('insAna', InsAna)
Vue.component('nc', Nc)
Vue.component('anaDetail', AnaDetail)
Vue.component('autoCompleteAna', AutoCompleteAna)
Vue.component('photoCarusel',PhotoCarusel)
Vue.use(VueRouter)
export const router = new VueRouter({
  mode: 'history',
  base: '/nc/',
  routes: [
    {
      path: '/', name: 'root', component: Home, meta: {
        auth: false,
        title: 'Home'
      }
    },

    {
      path: '/home', name: 'home', component: Home, meta: {
        auth: false,
        title: 'Home'
      }
    },
    {
      path: '/listaAc', name: 'listaAc', component: ListaAc, meta: {
        auth: true,
        title: 'Vie'
      }
    },
    {
      path: '/stampe', name: 'stampe', component: Stampe, meta: {
        auth: true,
        title: 'Stampe'
      }
    },
    
    {
      path: '/anagrafe', name: 'anagrafe', component: Anagrafe, meta: {
        auth: true,
        title: 'Anagrafe'
      }
    },

    {
      path: '/sceltaComune', name: 'sceltaComune', component: SceltaComune, meta: {
        auth: true,
        title: 'Scelta comune'
      }
    },
    {
      path: '/login', name: 'login', component: Login, meta: {
        auth: false,
        title: 'Login'
      }
    },
    {
      path: '/dettaglioAc/:prgAc', name: 'dettaglioAc', component: DettaglioAc, meta: {
        auth: true,
        title: 'Via'
      }
    },
    {
      path: '/dettaglioNc/:prgAc/:prgInd', name: 'dettaglioNc', component: DettaglioNc, meta: {
        auth: true,
        title: 'Civico'
      }
    },
    {
      path: '/dettaglioAna/:anaType/:prgAna', name: 'dettaglioAna', component: DettaglioAna, meta: {
        auth: true,
        title: 'Anagrafica'
      }
    },
    {
      path: '/office/rilievi/:acUid', name: 'rilievi', component: Rilievi, meta: {
        auth: true,
        title: 'Rilievi'
      }
    },
    
    
    {
      path: '*', redirect: '/home'
    }
  ]
})

export default {

  components: {
    VueSuggestion,
    MapTemplate
  }
}

router.beforeEach((to, from, next) => {
  //alert(to.path)
  
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/home', '/logout'];
  const isPublicPage = ((publicPages.includes(to.path) || to.path.includes('/invitations/open/')));


  //const sessionId = localStorage.getItem('sid');
  const sessionId = userService.getSessionId()

  if (!isPublicPage && !sessionId) {
      //alert('login: sid='+sessionId)
    return next('/login');
  } else {
    if (to.path == '/' && sessionId) {
      next('/list');
    } else {
      next();
    }
  }


})

Vue.config.productionTip = false
Vue.prototype.$mapStorage=[];
new Vue({
  router,
  vuetify,
  iconfont: 'mdi',
  render: h => h(App)
}).$mount('#app')
